import { render, staticRenderFns } from "./StudySelect.vue?vue&type=template&id=dc1bf996&"
import script from "./StudySelect.vue?vue&type=script&lang=js&"
export * from "./StudySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports